import React from 'react'
import {
  RetainLibraryDataOrgSettingsToggle,
  RetainLibraryDataOrgSettingsToggleProps
} from '../../../sca/libraries/components/settings-toggles/retain-library-data-org-settings-toggle'
import { createNgReactBridgeDirective } from '../../react-bridge'

export function RetainLibraryDataOrgSettingsToggleWrapper({
  onToggle,
  enabled = false
}: RetainLibraryDataOrgSettingsToggleProps) {
  return (
    <RetainLibraryDataOrgSettingsToggle onToggle={onToggle} enabled={enabled} />
  )
}

export const retainLibraryDataOrgSettingsToggle = createNgReactBridgeDirective(
  'reactRetainLibraryDataOrgSettingsToggle',
  [],
  RetainLibraryDataOrgSettingsToggleWrapper,
  ['onToggle', 'enabled']
)
